import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { timer } from 'rxjs';
import { MatTooltip } from '@angular/material/tooltip';
import { TrackerFacade } from '@cpd-app/state/tracker';
import { MaterialUiModule } from '@cpd-app/shared-module/material-ui-module/material-ui.module';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'cpd-copy-button',
  templateUrl: './copy-button.component.html',
  styleUrls: ['./copy-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, MaterialUiModule, FontAwesomeModule]
})
export class CopyButtonComponent {
  @Input() public hasBorder = false;
  @Input() public returnLink: string;

  constructor(private trackerFacade: TrackerFacade) {}

  public copy(tooltip: MatTooltip): void {
    if (this.returnLink) {
      tooltip.show();
      navigator.clipboard.writeText(this.returnLink);
      this.trackerFacade.reportShared();

      const timeout$ = timer(2000).subscribe(() => {
        tooltip.hide();
        timeout$.unsubscribe();
      });
    }
  }
}
